<template>
  <div class="contactUsBlock" v-bind:class="[page]">
    <div class="container-fluid">
      <div class="content">
        <ContactUsLinks/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ContactUsLinks from './ContactUsLinks';


export default {
  name: 'ContactUsBar',
  components: { ContactUsLinks },
  computed: {
    ...mapState({

    }),
  },
  props: {
    page: { default: null },
  },
  methods: {
    ...mapActions({

    }),
  },
};

</script>


<style lang="scss" scoped>
@import "../../assets/scss/variables-b4"; /* grid-breakpoints */
.contactUsBlock {
  padding-right: 0;
  padding-left: 0;
}
.contactUsBlock.mainPage .content {
  background-color: rgba(0, 0, 0, 0.4);
}
.container-fluid {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}
.content {
  width: 100%;
  float: right;
  background: rgba(0,105,92, 0.9);
  text-align: right;
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 8px;
}

@media only screen and (max-width: map-get($grid-breakpoints, sm)) {
.container-fluid {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}
  .content {
    width: 100%;
  }

}

@media only screen and (min-width: map-get($grid-breakpoints, sm)) {
  .content {
    width: auto;
  }
.container-fluid {
  margin-left: 6%;
  margin-right: calc(6% - 16px);
  padding-left: 0;
  padding-right: 0;
}
}

@media only screen and (min-width: map-get($grid-breakpoints, md)) {
.container-fluid {
  margin-left: 8%;
  margin-right: calc(8% - 16px);
  padding-left: 1rem;
  padding-right: 1rem;
}
}
/*
@media only screen and (max-width: map-get($grid-breakpoints, xl)) {
  .container-fluid {
    margin-left: 6%;
    margin-right: 6%;
    padding-right: 15px;
    padding-left: 15px;
  }

}
*/

</style>




// WEBPACK FOOTER //
// ContactUsBar.vue?a38fef26